import { FileText, Folder as FolderIcon, Pill } from 'lucide-react';
import { useParams } from 'react-router';
import { ENoteTypeFile } from '@enums/NoteTypeFile';
import { cn } from '@lib/ui/cn';
import { type Note } from '@models/Note';

import { type IOpenMoveFolderInputData } from '..';

const colorOptions = [
  { class: 'fill-[#EC313D] text-[#EC313D]', color: '#EC313D' },
  { class: 'fill-[#EC8031] text-[#EC8031]', color: '#EC8031' },
  { class: 'fill-[#ECC331] text-[#ECC331]', color: '#ECC331' },
  { class: 'fill-[#35EC31] text-[#35EC31]', color: '#35EC31' },
  { class: 'fill-[#31EC9E] text-[#31EC9E]', color: '#31EC9E' },
  { class: 'fill-[#31A9EC] text-[#31A9EC]', color: '#31A9EC' },
  { class: 'fill-[#3144EC] text-[#3144EC]', color: '#3144EC' },
  { class: 'fill-[#A531EC] text-[#A531EC]', color: '#A531EC' },
  { class: 'fill-[#EC31D9] text-[#EC31D9]', color: '#EC31D9' },
  { class: 'fill-[#EC3174] text-[#EC3174]', color: '#EC3174' },
  { class: 'fill-[#11824C] text-[#11824C]', color: '#11824C' },
  { class: 'fill-[#0B0964] text-[#0B0964]', color: '#0B0964' },
  { class: 'fill-[#69082B] text-[#69082B]', color: '#69082B' },
  { class: 'fill-[#776B6F] text-[#776B6F]', color: '#776B6F' },
  { class: 'fill-[#C0B5B9] text-[#C0B5B9]', color: '#C0B5B9' },
  { class: 'fill-[#211F54] text-[#211F54]', color: '#211F54' },
];

interface IProps {
  data: Note;
  onNavigate(inputData: IOpenMoveFolderInputData): void;
}

function Item({ data, onNavigate }: IProps) {
  const params = useParams();

  function handleGoFolder(): void {
    onNavigate({
      id: data.id,
      title: data.title,
      folderOriginId: params.id ? params.id : null,
      category: data.category,
    });
  }

  return (
    <button
      className="flex w-full cursor-pointer flex-row items-center gap-2 border-t py-3 disabled:cursor-not-allowed disabled:opacity-50"
      disabled={data.category !== 'PASTA'}
      onClick={handleGoFolder}>
      {data.category === ENoteTypeFile.Folder && (
        <FolderIcon
          className={cn(
            'size-9',
            colorOptions.find((item) => item.color === data.color)?.class,
          )}
          strokeWidth={1.5}
        />
      )}
      {data.category === ENoteTypeFile.Drug && (
        <Pill className="size-9" strokeWidth={1.5} />
      )}
      {data.category === ENoteTypeFile.ConditionOrDisease && (
        <FileText className="size-9" strokeWidth={1.5} />
      )}
      <p>{data.title}</p>
    </button>
  );
}

export default Item;
